import ReactDOM from "react-dom/client";
import { ConfigProvider } from "antd";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Approuter from "./Routes/Approuter";
import antdTheme from "./theme/antdTheme";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import { ToastContainer } from 'react-toastify';
import "./assets/css/line-awesome.min.css";
import "./assets/css/material.css";
import "./assets/scss/main.scss";
import "./theme/theme-overrides.css";
// After `theme-overrides.css`: it re-opaques the pinned-cell hover tints that
// file sets translucently. See the header comment there for why.
import "./theme/sticky-columns.css";

import { AuthProvider } from 'context/userContext';
import { Provider } from "react-redux";
import store from "store/store";

// Disable console logs in production
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  
  // Replace console methods with no-op function in production
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
  
  // Keep error logging for production issues (console.error remains unchanged)
  // Optionally, you can also disable console.error by uncommenting the line below:
  // console.error = noop;
}

const root = ReactDOM.createRoot(document.getElementById("root"));

if (module.hot) {
  module.hot.accept()
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 60_000 },
  },
});

root.render(
  <Provider store={store}>
    <ConfigProvider theme={antdTheme}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Approuter />
          <ToastContainer />
        </AuthProvider>
      </QueryClientProvider>
    </ConfigProvider>
  </Provider>
);
